import Input from '@nerdwallet/home-app-lib/input';
import * as inputDefinitions from '@nerdwallet/home-app-lib/inputs';

import truncatedValidatorMessage from '../../config/truncatedValidatorMessage';

// Overrides
const insurance = new Input(inputDefinitions.homeownersInsurance);
const propertyTax = new Input(inputDefinitions.propertyTax);
const HOADues = new Input(inputDefinitions.HOADues);
const mortgageInsurance = new Input(inputDefinitions.mortgageInsurance);
insurance.validators = [truncatedValidatorMessage.bind(insurance)];

propertyTax.validators = [truncatedValidatorMessage.bind(propertyTax)];

HOADues.validators = [truncatedValidatorMessage.bind(HOADues)];

mortgageInsurance.validators = [
  truncatedValidatorMessage.bind(mortgageInsurance),
];

const inputLibrary = {
  annualInterestRate: new Input(inputDefinitions.annualInterestRate),
  city: new Input(inputDefinitions.city),
  downPayment: new Input(inputDefinitions.downPayment),
  HOADues,
  loanTerm: new Input(inputDefinitions.loanTerm),
  homeownersInsurance: insurance,
  mortgageInsurance,
  propertyTax,
  purchasePrice: new Input(inputDefinitions.purchasePrice),
  loanStartDate: new Input(inputDefinitions.loanStartDate),
};

export default inputLibrary;
